import * as t from "io-ts"

const AttachmentUploadUrlSuccess = t.type({
    fileName: t.string,
    upload_url: t.string,
    form_fields: t.record(t.string, t.any),
})

const AttachmentUploadUrlError = t.type({
    fileName: t.string,
    error_reason: t.string,
})

const AttachmentUploadUrl = t.union([
    AttachmentUploadUrlSuccess,
    AttachmentUploadUrlError,
])

export const AttachmentUploadUrlResponse = t.intersection([
    t.type({
        urls: t.array(AttachmentUploadUrl),
    }),
    t.partial({
        deviceRef: t.string,
    }),
])

export type TAttachmentUploadUrlResponse = t.TypeOf<
    typeof AttachmentUploadUrlResponse
>

export type TAttachmentUploadUrl = t.TypeOf<typeof AttachmentUploadUrl>

export type TAttachmentUploadUrlSuccess = t.TypeOf<
    typeof AttachmentUploadUrlSuccess
>

export type TAttachmentUploadUrlError = t.TypeOf<
    typeof AttachmentUploadUrlError
>
